import React from 'react'

export default function Section1() {
    return (
        <div className='flex-grow flex items-center pb-10 lg:pb-20'>
            <div className='w-[90%] mx-auto'>
                <div className='zoom-in flex justify-center' style={{ fontFamily: 'Inter' }}>
                    <h1 className='bg-gradient-to-r from-[#005EA2] to-[#01C3FD] font-bold text-3xl lg:text-[60px] bg-clip-text text-transparent'>Trade with Confidence</h1>
                </div>
                <p className='zoom-in text-center lg:w-[60%] mx-auto mt-2 mb-5'>Finkey Star Is your one-stop platform for over-the-counter (OTC) cryptocurrency trading, designed to make transactions simple, secure, and efficient. Whether you’re a retail trader or an institutional investor, our platform ensures that you have seamless access to the digital asset market.  </p>
                <div className='lg:h-[270px] flex justify-center items-center relative overflow-hidden '>
                    <img src='https://fish-nft.s3.ap-south-1.amazonaws.com/crypt.gif' className='lg:absolute '></img>
                </div>
            </div>
        </div>
    )
}
